var _excluded = ["onSubmit", "defaultValues", "children", "loading"];
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Form } from "../Form";
import { Modal } from "../Modal";
import { Paper } from '@material-ui/core';
import React from 'react';
import { Loading } from "../Loading";
import { Box } from "../Box";
/**
 * The component is needed in order to wrap the Modal contents AND the
 * footerButtons in a `Form`.  Otherwise the submit button won't be associated
 * with the Form
 *
 * It uses `PaperComponent` and `PaperProps` to do this.
 *
 * @param props
 * @returns
 */
export function FormModal(props) {
  return /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
    // @ts-expect-error Not adding `Paper` to `Modal` props as we don't widespread use of this
    PaperComponent: ModalWrapper,
    PaperProps: {
      onSubmit: props.onSubmit,
      defaultValues: props.defaultValues,
      loading: props.loading
    },
    maxWidth: props.maxWidth
  }));
}
function ModalWrapper(props) {
  var onSubmit = props.onSubmit,
    defaultValues = props.defaultValues,
    children = props.children,
    loading = props.loading,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Paper, otherProps, loading ? /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    justifyContent: "center",
    mt: 2,
    mb: 2
  }, /*#__PURE__*/React.createElement(Loading, null)) : /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    defaultValues: defaultValues
  }, children));
}